<template>
	<ActivityBadgeLayout class="name-change-activity-badge">
		<FontAwesomeIcon :icon="[ `fas`, `input-text` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "NameChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

.name-change-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
